import { Group } from '@studio/design-system/toggle/group';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { Item } from './item.jsx';
import type { TogglesProps } from './types.js';
import { GridLines, toGridLines } from '#~/control/index.js';
import { useAnalytics, EVENT_CATEGORIES, EVENT_NAMES } from '#~/analytics/index.js';

/** `<Toggles>` component. */
export const Toggles = ({ gridLines, ...props }: TogglesProps): ReactElement => {
  const { track } = useAnalytics();

  const handleValueChange = useLatestFn((nextValue: string) => {
    const nextGridLines = toGridLines(nextValue);

    if (nextGridLines) {
      gridLines.setValue(nextGridLines);
      track(EVENT_NAMES.TOGGLE_PTZ_GRID_LINES, EVENT_CATEGORIES.GRIDLINES, {
        gridLines: nextGridLines
      });
    }
  });

  return (
    <div {...props}>
      <Group
        className='gap-4 bg-unset'
        onValueChange={handleValueChange}
        type='single'
        value={gridLines.value}
      >
        <Item value={GridLines.Thirds} />
        <Item value={GridLines.Center} />
        <Item value={GridLines.None} />
      </Group>
    </div>
  );
};
